import React from 'react';
import { X, MessageCircle } from 'lucide-react';

export default function WhatsAppComingSoonModal({ onClose }) {
  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4">
      <div className="bg-card rounded-2xl shadow-xl w-full max-w-sm p-6 space-y-5">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-bold">Send via WhatsApp</h2>
          <button onClick={onClose} className="text-muted-foreground hover:text-foreground">
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="flex flex-col items-center py-6 space-y-4 text-center">
          <div className="relative flex items-center justify-center">
            <div className="absolute w-20 h-20 rounded-full bg-emerald-100 animate-ping opacity-30" />
            <div className="relative w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center">
              <MessageCircle className="h-8 w-8 text-emerald-600" />
            </div>
          </div>
          <div>
            <p className="text-base font-bold text-foreground">WhatsApp Integration Coming Soon</p>
            <p className="text-sm text-muted-foreground mt-1.5 max-w-xs">
              You'll be able to send bills and payment reminders directly to customers' WhatsApp with one tap.
            </p>
          </div>
          <div className="flex items-center gap-1.5 text-xs text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-full px-3 py-1">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse inline-block" />
            We're working on it
          </div>
        </div>

        <button
          onClick={onClose}
          className="w-full border border-border rounded-xl py-2.5 text-sm font-medium hover:bg-muted transition-colors"
        >
          Close
        </button>
      </div>
    </div>
  );
}
